import { setMessageResponse, toggleLoadingIndicator } from "../system/actions";
import { AppThunk } from "../thunks";
import {postRegisterGeiEventAPI,putRegisterGeiEventAPI,putActivoGeiEventAPI,putRegisterStatusGeiEventAPI,getGeiEventByIdAPI, getGeiEventScheduleByEventIdAPI, 
    getGeiEventActivityByScheduleIdAPI, postGeiEventActivityAPI, getGeiEventResultsAPI, deleteGeiEventActivityByIdAPI, getEmissionsByTypeIdAPI, putScheduleGeiEventAPI, putGeiActivityEventAPI } from "../../services/restcall";
import { MessageResponse } from "../system/types";
import { serverMessages } from "../serverMessages";
import { GeiEventsRegister, GeiEventsUpdate, GeiEvents, GeiEventStatus, GeiEventsActivityRegister, PutGeiEventsSchedule, GeiEventInactive, GeiEventsActivityUpdate } from "./types";
//import { GeiEventStatus } from "./types";
import { openNotification } from "../../globals/Components/Notification/Notificaction";
import validateMessages from "../../globals/Inputs/validateMessages";

export const postRegisterGeiEvent = (value:GeiEventsRegister): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await postRegisterGeiEventAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
        openNotification("Advertencia",message.message[0]);      
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Gei Evento "+validateMessages.registerSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putRegisterGeiEvent = (value:GeiEventsUpdate): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putRegisterGeiEventAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);         
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Gei Evento "+ validateMessages.updateSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putActivoGeiEvent = (value: GeiEventInactive): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putActivoGeiEventAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);         
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Evento "+ validateMessages.deleteSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putGeiActivityEvent = (value: GeiEventsActivityUpdate): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putGeiActivityEventAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);         
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Evento "+ validateMessages.updateSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};
export const putRegisterStatusGeiEvent = (value:GeiEventStatus): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putRegisterStatusGeiEventAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);         
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Gei Evento Estado "+ validateMessages.updateSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const putScheduleGeiEvent = (value:PutGeiEventsSchedule): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await putScheduleGeiEventAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);     
        openNotification("Advertencia",message.message[0]);         
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Actualización","Fecha Actualizada  "+ validateMessages.updateSuccess);  
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const getGeiEventById = (page:number, pageSize:number,id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGeiEventByIdAPI(page,pageSize,id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getGeiEventScheduleByEventId = (id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGeiEventScheduleByEventIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getGeiEventActivityByScheduleId = (id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGeiEventActivityByScheduleIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const postGeiEventActivity = (value:GeiEventsActivityRegister): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    
    const responseData = await postGeiEventActivityAPI(value);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);  
        openNotification("Advertencia",message.message[0]);      
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        openNotification("Ingreso","Gei Evento "+validateMessages.registerSuccess); 
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getGeiEventResults = (id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getGeiEventResultsAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};

export const getEmissionsByTypeId = (typeId:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await getEmissionsByTypeIdAPI(typeId);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


export const deleteGeiEventActivityById = (id:string): AppThunk => async (dispatch) => {
    
    dispatch(toggleLoadingIndicator(true));
    dispatch(setMessageResponse(null));
    const responseData = await deleteGeiEventActivityByIdAPI(id);
    if (responseData.Error !== null) {
        let message: MessageResponse;
        message = serverMessages(responseData);       
        dispatch(setMessageResponse(message));
    }
    else if (responseData.StatusCode === 200) {
        dispatch(setMessageResponse(null));    
        dispatch(toggleLoadingIndicator(false));
        return responseData.Response;
    }
    dispatch(toggleLoadingIndicator(false));
};


